export const PASSWORD_UPDATE_ACTION =  'PasswordUpdateRequired'
export const TWO_FACTOR_ACTION =  'TwoFactorRequired'
export const REENABLE_ACCOUNT_ACTION =  'ReenableAccount'
export const CHECK_CREDENTIALS_ACTION =  'CheckCredentials'
export const PASSWORD_MAX_ATTEMPTS_ACTION =  'PasswordMaxAttempts'
export const TERMS_AND_CONDITIONS_ACTION =  'TermsAndConditions'
export const PRIVACY_POLICY_ACTION = 'PrivacyPolicy'


// WEBPACK FOOTER //
// ./src/constants/loginAdditionalActions.js